// extracted by mini-css-extract-plugin
module.exports = {"h2":"index-template-module--h2--1uaXk","forwardarrow":"index-template-module--forwardarrow--1l9oo","page":"index-template-module--page--ioXZa"};